/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CatalogItemResponseDto,
  CreateCatalogItemDto,
  GetCatalogForSupplier200Response,
  ProductCatalogResponseDto,
  RemoveCatalogItem200Response,
  UpdateCatalogItemDto,
} from '../models/index';
import {
    CatalogItemResponseDtoFromJSON,
    CatalogItemResponseDtoToJSON,
    CreateCatalogItemDtoFromJSON,
    CreateCatalogItemDtoToJSON,
    GetCatalogForSupplier200ResponseFromJSON,
    GetCatalogForSupplier200ResponseToJSON,
    ProductCatalogResponseDtoFromJSON,
    ProductCatalogResponseDtoToJSON,
    RemoveCatalogItem200ResponseFromJSON,
    RemoveCatalogItem200ResponseToJSON,
    UpdateCatalogItemDtoFromJSON,
    UpdateCatalogItemDtoToJSON,
} from '../models/index';

export interface AddCatalogItemRequest {
    createCatalogItemDto: CreateCatalogItemDto;
}

export interface GetCatalogForSupplierRequest {
    query?: string;
    page?: number;
    pageSize?: number;
    orderBy?: Array<string>;
}

export interface RemoveCatalogItemRequest {
    itemId: number;
}

export interface UpdateCatalogItemRequest {
    itemId: number;
    updateCatalogItemDto: UpdateCatalogItemDto;
}

/**
 * 
 */
export class ProductCatalogServiceApi extends runtime.BaseAPI {

    /**
     * Add a product to the catalog
     */
    async addCatalogItemRaw(requestParameters: AddCatalogItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatalogItemResponseDto>> {
        if (requestParameters['createCatalogItemDto'] == null) {
            throw new runtime.RequiredError(
                'createCatalogItemDto',
                'Required parameter "createCatalogItemDto" was null or undefined when calling addCatalogItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/product-catalog/items`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCatalogItemDtoToJSON(requestParameters['createCatalogItemDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CatalogItemResponseDtoFromJSON(jsonValue));
    }

    /**
     * Add a product to the catalog
     */
    async addCatalogItem(requestParameters: AddCatalogItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatalogItemResponseDto> {
        const response = await this.addCatalogItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new catalog for supplier organization
     */
    async createCatalogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductCatalogResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/product-catalog`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductCatalogResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create a new catalog for supplier organization
     */
    async createCatalog(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductCatalogResponseDto> {
        const response = await this.createCatalogRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get catalog items for logged in supplier with pagination and search
     */
    async getCatalogForSupplierRaw(requestParameters: GetCatalogForSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCatalogForSupplier200Response>> {
        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/product-catalog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCatalogForSupplier200ResponseFromJSON(jsonValue));
    }

    /**
     * Get catalog items for logged in supplier with pagination and search
     */
    async getCatalogForSupplier(requestParameters: GetCatalogForSupplierRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCatalogForSupplier200Response> {
        const response = await this.getCatalogForSupplierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a product from the catalog
     */
    async removeCatalogItemRaw(requestParameters: RemoveCatalogItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RemoveCatalogItem200Response>> {
        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling removeCatalogItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/product-catalog/items/{itemId}`.replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters['itemId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RemoveCatalogItem200ResponseFromJSON(jsonValue));
    }

    /**
     * Remove a product from the catalog
     */
    async removeCatalogItem(requestParameters: RemoveCatalogItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RemoveCatalogItem200Response> {
        const response = await this.removeCatalogItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a catalog item
     */
    async updateCatalogItemRaw(requestParameters: UpdateCatalogItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatalogItemResponseDto>> {
        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling updateCatalogItem().'
            );
        }

        if (requestParameters['updateCatalogItemDto'] == null) {
            throw new runtime.RequiredError(
                'updateCatalogItemDto',
                'Required parameter "updateCatalogItemDto" was null or undefined when calling updateCatalogItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/product-catalog/items/{itemId}`.replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters['itemId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCatalogItemDtoToJSON(requestParameters['updateCatalogItemDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CatalogItemResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update a catalog item
     */
    async updateCatalogItem(requestParameters: UpdateCatalogItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatalogItemResponseDto> {
        const response = await this.updateCatalogItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
